import { createContext } from 'react';

const DocumentAnnotationContext = createContext();
const DocumentCompareContext = createContext();
const DocumentCompareContextV = createContext();

export { DocumentAnnotationContext, DocumentCompareContext, DocumentCompareContextV };
